// Core
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// Chakra imports
import { Box, SimpleGrid, Image, Flex, Link, List, ListItem, Heading, Text, useColorModeValue } from '@chakra-ui/react';

// Assets
import logo from 'assets/img/logo.png';

export default function Footer(props) {
  const borderColor = useColorModeValue('#CBE7FF', '#262D47');
  const textColor = useColorModeValue('blue.800', '#9FABCB');
  const mbListPage = '23px';

  return (
    <Flex
      flexDirection={{
        base: 'column',
        md: 'row',
      }}
      alignItems={{
        base: 'center',
        md: 'start',
      }}
      justifyContent="space-between"
      px={{base: '15px', lg: '32px'}}
      pb="20px"
      borderTopWidth="0.05em"
      borderColor={borderColor}
      pt="32px"
      pb="32px"
    >
    	<SimpleGrid columns={{ base: 1, sm: 2, md: 5 }} rowGap="40px" maxW="1128px" w="100%" m="0 auto">
		  <Box>
	    	<Box mb='16px'>
	          <NavLink to="/">
	            <Image src={logo} alt='lmctplus logo' maxWidth="148px"/>
	          </NavLink>
	        </Box>
	        <Text variant="text-xs" color={textColor}>Copyright {new Date().getFullYear()}. LMCT PLUS</Text>
	      </Box>

	      <Box 
	      	display={{base: 'block', md: 'none'}} 
	      	w="100%" 
	      	textAlign={{base: 'left', sm: 'right'}}>
	        <Text variant="title" mb='14px' fontSize={'14px'}>ABN</Text>
	        <Text variant="text-sm" color={textColor}>93 627 297 474<br />
	          Level 2, 161<br />
			  Collins Street,<br />
	          Melbourne 3000</Text>
	      </Box>

		  <Box ml={{md: '20px'}} mr={{md: '-20px'}}> 
		    <List>
		        <ListItem me={{ base: '20px', md: '44px' }} mb={mbListPage}>
		            <Text variant="link-sm">
		                <NavLink to="giveaways">Giveaways</NavLink>
		            </Text>
		        </ListItem>
		        <ListItem me={{ base: '20px', md: '44px' }} mb={mbListPage}>
		            <Text variant="link-sm">
		                <NavLink to="/membership">Membership</NavLink>
		            </Text>
		        </ListItem>
		        {/*<ListItem me={{ base: '20px', md: '44px' }}>
		            <Text variant="link-sm">
		                <NavLink to="/previous-winners">Previous winners</NavLink>
		            </Text>
		        </ListItem>*/}
		    </List>
		  </Box>

		  <Box> 
		    <List>
		        <ListItem me={{ base: '20px', md: '44px' }} mb={mbListPage}>
		            <Text variant="link-sm">
		                <NavLink to="/become-a-partner">Become a Partner</NavLink>
		            </Text>
		        </ListItem>
		        <ListItem me={{ base: '20px', md: '44px' }} mb={mbListPage}>
		            <Text variant="link-sm">
		                <NavLink to="/about">About</NavLink>
		            </Text>
		        </ListItem>
		        <ListItem me={{ base: '20px', md: '44px' }}>
		            <Text variant="link-sm">
		                <NavLink to="/faqs">FAQ</NavLink>
		            </Text>
		        </ListItem>
		    </List>
		  </Box>

		  <Box> 
		    <List>
		        <ListItem me={{ base: '20px', md: '44px' }} mb={mbListPage}>
		            <Text variant="link-sm">
		                <NavLink to="/contact-support">Contact Support</NavLink>
		            </Text>
		        </ListItem>
		        <ListItem me={{ base: '20px', md: '44px' }} mb={mbListPage}>
		            <Text variant="link-sm">
		                <NavLink to="/terms-and-conditions">Terms & Conditions</NavLink>
		            </Text>
		        </ListItem>
		        <ListItem me={{ base: '20px', md: '44px' }}>
		            <Text variant="link-sm">
		                <NavLink to="/privacy-policy">Privacy Policy</NavLink>
		            </Text>
		        </ListItem>
		    </List>
		  </Box>

	      <Box display={{base: 'none', md: 'block'}} w="100%" textAlign="right">
	        <Text variant="title" mb='14px' fontSize={'14px'}>ABN</Text>
	        <Text variant="text-sm" color={textColor}>93 627 297 474<br />
	          Level 2, 161<br />
			  Collins Street,<br />
	          Melbourne 3000</Text>
	      </Box>
    	</SimpleGrid>
    </Flex>
  );
}
